import { useQuery, type UseQueryResult } from '@tanstack/react-query';

import type {
  CampaignAuditResponseDto,
  RankAdminClient,
} from '@/api/rank-admin-client';
import { useRankAdminClient } from '@/api/rank-admin-client-context';

// =============================================================================
// use-campaign-audit.ts — Hook TanStack Query de la PAGE d'audit campagne (LANE-E-CAMPAIGN-AUDIT).
// =============================================================================
// Une seule lecture (useQuery) — aucune mutation (admin LIT, invariant n°1 ; audit append-only). Le client
// effectif vient du RankAdminClientProvider (doublable, stub-first). ZÉRO règle métier ici : l'autorité
// (RBAC AdminSessionGuard, lecture audit_entry via port ACL, tri occurredAt DESC, flag irréversible A0R-11
// dérivé à la lecture) est l'API. Le front LIT et habille.

const CAMPAIGN_AUDIT_KEY = ['campaign-audit'] as const;

/** Clé de query stable de la page d'audit d'une campagne. */
export function campaignAuditKey(campaignId: string): readonly unknown[] {
  return [...CAMPAIGN_AUDIT_KEY, campaignId];
}

/**
 * Page d'audit d'une campagne (A0R-9) : liste des actions auditées horodatées, plus récent d'abord, chaque
 * entrée irréversible (A0R-11) signalée. Liste VIDE possible (aucune action auditée = état normal).
 */
export function useCampaignAudit(
  campaignId: string,
): UseQueryResult<CampaignAuditResponseDto, Error> {
  const client: RankAdminClient = useRankAdminClient();
  return useQuery<CampaignAuditResponseDto, Error>({
    queryKey: campaignAuditKey(campaignId),
    queryFn: () => client.getCampaignAudit(campaignId),
  });
}
